"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateRangePicker = void 0;
var react_1 = __importDefault(require("react"));
var __1 = require("../");
var components_1 = require("./components");
var kendo_react_dateinputs_1 = require("@progress/kendo-react-dateinputs");
var utilities_1 = require("../../utilities");
var utils_1 = require("./utils");
var checkScope_1 = require("./utils/checkScope");
var DateRangePicker = function (_a) {
    var _b, _c, _d, _e;
    var 
    // for trigger
    _f = _a.size, 
    // for trigger
    size = _f === void 0 ? 'medium' : _f, disabled = _a.disabled, error = _a.error, placeholder = _a.placeholder, required = _a.required, 
    // for popover
    options = _a.options, _g = _a.direction, direction = _g === void 0 ? 'br' : _g, open = _a.open, disableCloseOnClickOutside = _a.disableCloseOnClickOutside, onClickOutside = _a.onClickOutside, 
    // for calendar
    value = _a.value, defaultValue = _a.defaultValue, onChange = _a.onChange, maxDate = _a.maxDate, minDate = _a.minDate, focusedDate = _a.focusedDate, 
    // for inputs
    _h = _a.startPlaceholder, 
    // for inputs
    startPlaceholder = _h === void 0 ? 'Start Date' : _h, _j = _a.endPlaceholder, endPlaceholder = _j === void 0 ? 'End Date' : _j;
    var triggerRef = react_1.default.useRef(null);
    var _k = react_1.default.useState(error), IError = _k[0], setIError = _k[1];
    var _l = react_1.default.useState({
        start: false,
        end: false,
    }), inputErrors = _l[0], setInputErrors = _l[1];
    var validRange = react_1.default.useCallback(function (d) {
        return {
            start: utils_1.toDateFormat.startOfDay(d === null || d === void 0 ? void 0 : d.start),
            end: utils_1.toDateFormat.endOfDay(d === null || d === void 0 ? void 0 : d.end),
        };
    }, []);
    var _m = react_1.default.useState(validRange(value)), dateRange = _m[0], setDateRange = _m[1];
    var _o = react_1.default.useState(validRange(value)), IValue = _o[0], setIValue = _o[1];
    var _p = react_1.default.useState(validRange(value)), triggerValue = _p[0], setTriggerValue = _p[1];
    var _q = react_1.default.useState(open), openCal = _q[0], setOpenCal = _q[1];
    var _r = react_1.default.useState(disableCloseOnClickOutside), disableFocus = _r[0], setDisableFocus = _r[1];
    var _s = react_1.default.useState({
        start: false,
        end: false,
    }), IsOutOfRange = _s[0], setIsOutOfRange = _s[1];
    var minMaxRange = react_1.default.useMemo(function () {
        return {
            min: minDate && utils_1.toDateFormat.startOfDay(minDate),
            max: maxDate && utils_1.toDateFormat.endOfDay(maxDate),
        };
    }, [minDate, maxDate]);
    var isNewDateRange = ((_b = IValue === null || IValue === void 0 ? void 0 : IValue.start) === null || _b === void 0 ? void 0 : _b.getTime()) !== ((_c = dateRange === null || dateRange === void 0 ? void 0 : dateRange.start) === null || _c === void 0 ? void 0 : _c.getTime()) ||
        ((_d = IValue === null || IValue === void 0 ? void 0 : IValue.end) === null || _d === void 0 ? void 0 : _d.getTime()) !== ((_e = dateRange === null || dateRange === void 0 ? void 0 : dateRange.end) === null || _e === void 0 ? void 0 : _e.getTime());
    // Checks min and max dates for start and end date
    var checkDateRangeScope = react_1.default.useCallback(function (range) {
        var _a, _b;
        var isOutOfScope = checkScope_1.checkScope(range, minDate, maxDate);
        setIsOutOfRange({
            start: isOutOfScope.startOutOfScope
                ? "Min date is " + utils_1.toDateFormat.numeric((_a = utils_1.toDateFormat.startOfDay(minDate)) === null || _a === void 0 ? void 0 : _a.getTime())
                : false,
            end: isOutOfScope.endOutOfScope
                ? "Max date is " + utils_1.toDateFormat.numeric((_b = utils_1.toDateFormat.endOfDay(maxDate)) === null || _b === void 0 ? void 0 : _b.getTime())
                : false,
        });
    }, [maxDate, minDate]);
    // this functions as a stopper to only run calendar onChange when 2 onChanges conflict
    var preventOnChange = false;
    // handler for MultiViewCalendar onChange
    var handleCalendarOnChange = function (event) {
        var eventValue = event.target.value;
        setDateRange(eventValue);
        setInputErrors({ start: false, end: false });
        setIsOutOfRange({ start: false, end: false });
        preventOnChange = true;
    };
    // handler for DateInput onBlur
    var handleDateOnBlur = function (type, data) {
        var _a, _b;
        if (!preventOnChange) {
            setDateRange(__assign(__assign({}, dateRange), (_a = {}, _a[type] = data, _a)));
            checkDateRangeScope(__assign(__assign({}, dateRange), (_b = {}, _b[type] = data, _b)));
        }
    };
    // confirm handler, this returns dateRange value through onChange
    var handleOnConfirm = function () {
        onChange({
            start: utils_1.toDateFormat.startOfDay(dateRange.start),
            end: utils_1.toDateFormat.endOfDay(dateRange.end),
        });
        setTriggerValue(dateRange);
        setIValue(dateRange);
        setOpenCal(false);
    };
    // close popover function - this will revert dateRange to initial value
    var close = function () {
        if (openCal) {
            setDateRange(IValue);
            setOpenCal(false);
            triggerRef.current.focus();
        }
    };
    var handleOnClickOutside = function () {
        if (openCal) {
            onClickOutside === null || onClickOutside === void 0 ? void 0 : onClickOutside();
            if (!disableCloseOnClickOutside) {
                setDateRange(IValue);
                setOpenCal(false);
            }
        }
    };
    // toggle open state
    var toggleOpen = function () {
        openCal ? close() : setOpenCal(!openCal);
        if (disableCloseOnClickOutside) {
            setDisableFocus(false);
        }
    };
    // keyboard event for end date input to confirm and close
    var calendarKeyPress = function (event) {
        if (event.code === utilities_1.Keys.Space && !isApplyDisabled) {
            handleOnConfirm();
            event.preventDefault();
        }
    };
    var clearDateRange = function (d) {
        close();
        setDateRange(d);
        setIValue(d);
        checkDateRangeScope(d);
    };
    // keyboard event for trigger to open popover
    var triggerKeyPress = function (event) {
        (event.code === utilities_1.Keys.Enter || event.code === utilities_1.Keys.Space) &&
            setOpenCal(true);
    };
    // Update internal states with incoming value
    react_1.default.useEffect(function () {
        setDateRange(validRange(value));
        setIValue(validRange(value));
        setTriggerValue(validRange(value));
        checkDateRangeScope(value);
    }, [checkDateRangeScope, validRange, value]);
    // Handles when open prop changes
    react_1.default.useEffect(function () {
        setOpenCal(open);
    }, [open]);
    // Update error states when out of scope state changes
    react_1.default.useEffect(function () {
        setInputErrors({ start: IsOutOfRange.start, end: IsOutOfRange.end });
    }, [IsOutOfRange, minMaxRange]);
    // Update trigger error on apply && initial load
    react_1.default.useEffect(function () {
        if (inputErrors.start || inputErrors.end) {
            setIError(true);
        }
    }, [IValue, inputErrors]);
    var isApplyDisabled = (!dateRange.start ||
        !dateRange.end ||
        !isNewDateRange ||
        inputErrors.start ||
        inputErrors.end ||
        !IsOutOfRange);
    return (react_1.default.createElement(__1.Popover, { open: !disabled && openCal, onClickOutside: handleOnClickOutside, trigger: react_1.default.createElement(components_1.DateRangeTrigger, { open: openCal, placeholder: placeholder !== null && placeholder !== void 0 ? placeholder : 'Select Date Range', onClick: toggleOpen, onKeyDown: triggerKeyPress, onChange: clearDateRange, value: triggerValue, disabled: disabled, error: IError, size: size, ref: triggerRef, required: required }), direction: direction, padding: null, width: "auto", className: "DateRangePicker__popover", portal: true, focusScopeOptions: {
            disableTrapping: !openCal,
            disableAutofocus: disableFocus ? true : !openCal,
        } },
        react_1.default.createElement(__1.KeyPressListener, { code: utilities_1.Keys.Esc, handler: close, disabled: disableCloseOnClickOutside || !openCal }),
        react_1.default.createElement("div", { className: "d-f flex-row" },
            options && options.length > 0 && (react_1.default.createElement(components_1.DateRangeOptionList, { options: options, min: minMaxRange.min, max: minMaxRange.max, onChange: function (data) {
                    setTriggerValue(data);
                    setDateRange(data);
                    onChange(data);
                    setOpenCal(false);
                } })),
            react_1.default.createElement("div", { className: "DateRangePicker" },
                react_1.default.createElement("div", { className: "DateRangePicker__header" },
                    react_1.default.createElement("div", { className: "DateRangePicker__inputGroup" },
                        react_1.default.createElement(components_1.DateRangeInput, { placeholder: startPlaceholder, value: dateRange.start, error: inputErrors.start, onBlur: function (value) {
                                handleDateOnBlur('start', value);
                            } }),
                        react_1.default.createElement(__1.Icon, { name: "arrow_forward", className: "DateRangePicker__fromTo" }),
                        react_1.default.createElement(components_1.DateRangeInput, { placeholder: endPlaceholder, value: dateRange.end, error: inputErrors.end, onBlur: function (value) {
                                handleDateOnBlur('end', value);
                            } }))),
                react_1.default.createElement("div", { onKeyPress: calendarKeyPress },
                    react_1.default.createElement(kendo_react_dateinputs_1.MultiViewCalendar, { mode: "range", views: 1, value: dateRange, onChange: handleCalendarOnChange, focusedDate: focusedDate, defaultValue: defaultValue, min: minMaxRange.min, max: minMaxRange.max })))),
        react_1.default.createElement(__1.ButtonGroup, { className: "DateRangePicker__actions" },
            react_1.default.createElement(__1.Button, { disabled: isApplyDisabled, onClick: handleOnConfirm, small: true, color: "primary" }, "Apply"),
            react_1.default.createElement(__1.Button, { small: true, fill: "subtle", onClick: close }, "Cancel"))));
};
exports.DateRangePicker = DateRangePicker;
//# sourceMappingURL=DateRangePicker.js.map